/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
//import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'

var no_auth = ['/login','/forgot-password', '/no-permission']
// Routes
import paths from './paths'

function route (path, view, name) {
  return {
    name: name || view,
    path,
    component: (resovle) => import(
      `@/views/${view}.vue`
    ).then(resovle),
    beforeEnter: (to, from, next) => {
      console.log(from.name)
     var allowed_pages = []
     if(sessionStorage.allowed_pages) {
      allowed_pages = sessionStorage.allowed_pages != 'null'?JSON.parse(sessionStorage.allowed_pages):[]
     }
      if(no_auth.indexOf(to.path) == -1) {
        if(allowed_pages.indexOf(to.name) != -1) {
          next()
        }
      } else {
        next()
      }
    }
  }
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name)).concat([
    { path: '*', redirect: '/login' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

export default router
